import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IntegracaoService } from 'src/services/integracao.service';
import { TipoIntegracaoService } from 'src/services/tipo-integracao.service';
import * as moment from 'moment';
import { PermissoesService } from 'src/services/permissoes.service';
import { PessoaService } from 'src/services/pessoa.service';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-integrador',
    templateUrl: './integrador.component.html',
    styleUrls: ['./integrador.component.scss'],
    standalone: false
})
export class IntegradorComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  dataTipo: any[] = [];
  displayModalTipo: boolean = false;
  displayModal: boolean = false;
  loading: boolean = false;
  form: FormGroup;
  formTipo: FormGroup;
  dropDownPessoa: any[] = [];
  dropDownStatus: any[] = [
    { value: null, label: 'Selecione' },
    { value: 0, label: 'Ativo' },
    { value: 1, label: 'Inativo' },
    { value: 2, label: 'Cancelado' }
  ];
  direitoVisualizarIntegradores: boolean = false;
  direitoInserirIntegradores: boolean = false;
  direitoEditarIntegradores: boolean = false;
  direitoExcluirIntegradores: boolean = false;
  direitoVisualizarTipos: boolean = false;
  direitoInserirTipos: boolean = false;
  direitoEditarTipos: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  @ViewChild('tableWrapperTipo', { static: false }) tableWrapperTipo: ElementRef;
  scrollHeight: string = '600px';
  scrollHeightTipo: string = '600px';

  /** Modal de exclusão quando há estações vinculadas: usuário deve digitar "Excluir integrador" */
  modalExcluirComEstacoes: boolean = false;
  integradorParaExcluir: any = null;
  estacoesRelacionadas: Array<{ id: number; nome: string }> = [];
  inputExcluirIntegrador: string = '';
  readonly textoConfirmacaoExclusao = 'Excluir integrador';

  constructor(
    protected _formBuilder: FormBuilder,
    protected _integracaoService: IntegracaoService,
    protected _tipoIntegracaoService: TipoIntegracaoService,
    protected _pessoaService: PessoaService,
    protected permissaoService: PermissoesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) { }
  ngOnInit(): void {
    this.direitoVisualizarIntegradores = this.permissaoService.can('integradores_visualizar');
    this.direitoInserirIntegradores = this.permissaoService.can('integradores_inserir');
    this.direitoEditarIntegradores = this.permissaoService.can('integradores_editar');
    this.direitoExcluirIntegradores = this.permissaoService.can('config_integradores_excluir');
    this.direitoVisualizarTipos = this.permissaoService.can('config_tipo_integradores_visualizar');
    this.direitoInserirTipos = this.permissaoService.can('config_tipo_integradores_inserir');
    this.direitoEditarTipos = this.permissaoService.can('config_tipo_integradores_editar');

    this.form = this._formBuilder.group({
      id: [null],
      descricao: [null],
      tipo_integracao_id: [null],
      frequencia_execucao: [null],
      role_name: [null],
      ultima_data_hora_leitura: [null],
      ultima_data_hora_envio: [null],
      usuario_endpoint: [null],
      senha_endpoint: [null],
      pessoa_integracao_id: [null],
      usuario_integracao: [null],
      senha_integracao: [null],
      url: [null],
      status: [null],
      caminho: [null],
      hora_flu: [null],
      hora_plu: [null],
      hora_limite_flu: [null],
      hora_limite_plu: [null],
      dias_retroativos_flu: [null],
      dias_retroativos_plu: [null],
    })
    this.formTipo = this._formBuilder.group({
      id: [null],
      descricao: [null],
    })
    this.index()
    this.listPessoa()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
    if (this.tableWrapperTipo && this.tableWrapperTipo.nativeElement) {
      const wrapperHeight = this.tableWrapperTipo.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeightTipo = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  listPessoa(){
    this.dropDownPessoa = []
    this.dropDownPessoa.push({
      value: null, label: 'Selecione'
    })
    this._pessoaService.index().subscribe(json => {
      (json || []).forEach((item: any) => {
        if(item.integrador == true && item.ativo === true){
          this.dropDownPessoa.push({
            value: item.id, label: item.nome
          })
        }
      })
      
    })
  }
 
  index(){
    this._integracaoService.index().subscribe(json => {
      this.data = json || [];
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    })
    this._tipoIntegracaoService.index().subscribe(json => {
      this.dataTipo = json || [];
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    })
      }
    
      openNew(){
          this.form.reset()
          this.displayModal = true
      }
      openNewTipo(){
          this.formTipo.reset()
          this.displayModalTipo = true
      }
    
      edit(event){
        this._integracaoService.show(event.id).subscribe(json => {
          json.ultima_data_hora_envio = moment.utc(json.ultima_data_hora_envio).format('YYYY-MM-DD HH:mm')
          this.form.patchValue(json)
          this.displayModal = true
        })
    
      }
    
      editTipo(event){
        this._tipoIntegracaoService.show(event.id).subscribe(json => {
          this.formTipo.patchValue(json)
          this.displayModalTipo = true
        })
      }
    
      save(){
        this.loading = true
        let params = this.form.value
       console.log(params)
        params.tipo_integracao_id = params.tipo_integracao_id.id
        if(params.pessoa_integracao_id == 'null'){
          params.pessoa_integracao_id = null
        }
        this._integracaoService.save(params, params.id).subscribe(json => {
          this.loading = false
          this.index()
          this.displayModal = false
        }, err => {
          this.loading = false
        })
    
      }
    
      saveTipo(){
        this.loading = true
        let params = this.formTipo.value
        this._tipoIntegracaoService.save(params, params.id).subscribe(json => {
          this.loading = false
          this.index()
          this.displayModalTipo = false
        }, err => {
          this.loading = false
        })
      }

  /**
   * Antes de excluir, chama GET /api/configuracao-integracao/{id}/estacoes-relacionadas.
   * Se não houver estações: confirmação simples Sim/Não.
   * Se houver estações: abre modal onde o usuário deve digitar "Excluir integrador".
   */
  confirmarExclusao(integrador: any): void {
    this._integracaoService.getEstacoesRelacionadas(integrador.id).subscribe({
      next: (res: any) => {
        const existe = res?.existe === true;
        const estacoes = res?.estacoes ?? [];
        const temEstacoes = Array.isArray(estacoes) && estacoes.length > 0;
        if (!existe || !temEstacoes) {
          this.confirmarExclusaoSimples(integrador);
        } else {
          this.integradorParaExcluir = integrador;
          this.estacoesRelacionadas = estacoes;
          this.inputExcluirIntegrador = '';
          this.modalExcluirComEstacoes = true;
        }
      },
      error: (err) => {
        const msg = err?.error?.message || 'Configuração de integração não encontrada.';
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: msg,
        });
      },
    });
  }

  private confirmarExclusaoSimples(integrador: any): void {
    const descricao = integrador.descricao || `ID ${integrador.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o integrador "${descricao}" (código ${integrador.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirIntegrador(integrador.id),
    });
  }

  fecharModalExcluirComEstacoes(): void {
    this.modalExcluirComEstacoes = false;
    this.integradorParaExcluir = null;
    this.estacoesRelacionadas = [];
    this.inputExcluirIntegrador = '';
  }

  executarExclusaoComEstacoes(): void {
    if (!this.integradorParaExcluir || this.inputExcluirIntegrador !== this.textoConfirmacaoExclusao) return;
    this.excluirIntegrador(this.integradorParaExcluir.id);
    this.fecharModalExcluirComEstacoes();
  }

  /**
   * Chama DELETE /api/configuracao-integracao/{id}. Resposta 204 sucesso, 404 não encontrado.
   */
  private excluirIntegrador(id: number): void {
    this._integracaoService.destroy(id).subscribe({
      next: () => {
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Integrador excluído com sucesso.',
        });
        setTimeout(() => this.calculateScrollHeight(), 200);
      },
      error: (err) => {
        const status = err?.status;
        const msg = err?.error?.message || 'Configuração de integração não encontrada.';
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg || 'Integrador não encontrado. Removido da lista.',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg || 'Não foi possível excluir o integrador.',
          });
        }
      },
    });
  }
  }
